/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import useUserAvailableActions from './useUserAvailableActions';

const useUserHasAvailableAction = (availableAction) => {
  const availableActions = useUserAvailableActions({ notExpected: true, returnNull: true });

  if (!availableActions) return false;

  return availableActions.includes(availableAction);
};

export default useUserHasAvailableAction;
